// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — date-select.styled.classic.js, новая — date-select.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './date-select.styled.classic';
import * as cp from './date-select.styled.cp';

export const CalendarBox = isCp ? cp.CalendarBox : classic.CalendarBox;
export const DateInput = isCp ? cp.DateInput : classic.DateInput;
export const DateInputBox = isCp ? cp.DateInputBox : classic.DateInputBox;
export const Input = isCp ? cp.Input : classic.Input;
export const InputBox = isCp ? cp.InputBox : classic.InputBox;
